/* Config file */
export const config = {
    showError: 'showError',
    token: {
        validateMinutesInterval: 'validateMinutesInterval',
        renewMinutes: 'renewMinutes'
    },
    logInfoDevice: 'logInfoDevice',
    encryptStorage: 'encryptStorage',
    encryptKey: 'encryptKey',
    encryptKeyPassword: 'encryptKeyPassword',
    entraId: {
        rootBase: 'rootBase',
        clientId: 'clientId',
        tenantId: 'tenantId',
        authority: 'authority',
        redirectUri: 'redirectUri',
        redirectLogout: 'redirectLogout'
    },
    intervalWaitSSO: 'intervalWaitSSO',
    onlineHelp: {
        frenchLink: 'frenchLink',
        englishLink: 'englishLink',
    },
    companyTitle: 'companyTitle'
}
/* Config file */

// This will be all the encrypted parameters
export const appgoParams = 'appgo.params';

// This will be all the non encrypted parameters
export const knkParams = 'knk.params';


export const userCode = 'userCode';

export const userName = 'userName';

export const employeeId = 'employeeId';

export const menu = 'menu';

export const favouritesMenus = 'favouritesMenus';

export const abcUsage = 'abcUsage';

export const linkProjectPActivity = 'linkProjectPActivity';

export const language = 'language';

export const googleApiKey = 'googleApiKey';

export const token = 'token';

export const sessionGuid = 'sessionGuid';

export const expenseAccountActivities = 'expenseAccountActivities';

export const expandedTimesheet = 'expandedTimesheet';

export const startDayTimesheet = 'startDayTimesheet';

export const useTimeTimesheet = 'useTimeTimesheet';

export const useTimeTimesheetRequired = 'useTimeTimesheetRequired';

export const acceptedTermsUse = 'acceptedTermsUse';

export const termsUse = 'termsUse';

export const legalInfo = 'legalInfo';

export const showDateStatementTerms = 'showDateStatementTerms';

export const showDateStatementLegalInfo = 'showDateStatementLegalInfo';

export const scheduleReturnDate = 'scheduleReturnDate';

export const filterRequest = 'filterRequest';

export const hrRequestFilter = 'hrRequestFilter';

export const calendarRequest = 'calendarRequest';

export const isPasswordComplex = 'isPasswordComplex';

export const minLengthPassword = 'minLengthPassword';

export const clientHashKey = 'clientHashKey';

export const useGeolocation = 'useGeolocation';

export const useGeolocationZone = 'useGeolocationZone';

export const creditCardSupport = 'creditCardSupport';

export const companies = 'companies';

export const punchTime = 'punchTime';

export const colorCalendar = 'colorCalendar';

export const useWorkInstructions = 'useWorkInstructions';

export const displayMedicalData = 'displayMedicalData';

export const connectionString = 'connectionString';

export const displayDistributionSlip = 'displayDistributionSlip';

export const displayPreferenceCommunication = 'displayPreferenceCommunication';

export const displaySeniorityDate = 'displaySeniorityDate';

export const displayInactiveDate = 'displayInactiveDate';

export const displayHiringDate = 'displayHiringDate';

export const displayFirstDate = 'displayFirstDate';

export const displayLastDate = 'displayLastDate';

export const displayEmergencyContacts = 'displayEmergencyContacts';

export const displayCCQClassifications = 'displayCCQClassifications';

export const displayLastDevices = 'displayLastDevices';

export const displayBankBalances = 'displayBankBalances';

export const canEmployeeChangePhoto = 'canEmployeeChangePhoto';

export const displayBankingInformation = 'displayBankingInformation';

export const isCCQ = 'isCCQ';

export const partialRequestHoursUsed = 'partialRequestHoursUsed';

export const taxationProvince = 'taxationProvince';

export const filterExpenseAccount = 'filterExpenseAccount';

export const isMandatoryPhoneCellPerso = 'isMandatoryPhoneCellPerso';

export const isMandatoryEmailPerso = 'isMandatoryEmailPerso';

export const isDisplayPayAdvanceVacation = 'isDisplayPayAdvanceVacation';

export const isMandatorySMSPerso = 'isMandatorySMSPerso';

export const communicationPreference = 'communicationPreference';

export const isUsePartialRequest = 'isUsePartialRequest';

export const isSSO = 'isSSO';

export const isAuthSSO = 'isAuthSSO';

export const isDisplayPayablesHours = 'isDisplayPayablesHours';

export const isDisplayFlagFullTime = 'isDisplayFlagFullTime';

export const isUseMaterialResourceTimesheet = 'isUseMaterialResourceTimesheet';

export const showSubscribe = 'showSubscribe';

export const notificationPublicKey = 'notificationPublicKey';

export const notificationPrivateKey = 'notificationPrivateKey';

export const isNotificationActivate = 'isNotificationActivate';

export const isProfileConsultationMode = 'isProfileConsultationMode';

export const listPrefixConnection = 'listPrefixConnection';

export const isDisplayBankOthers = 'isDisplayBankOthers';

export const isDisplayBankVacation = 'isDisplayBankVacation';

export const useServiceProvider = 'useServiceProvider';

export const useAttendanceConfirmation = 'useAttendanceConfirmation';

export const useGeolocationMandatory = 'useGeolocationMandatory';

export const worksites = 'worksites';

export const hasEmpAccess = 'hasEmpAccess';

export const hasSupAccess = 'hasSupAccess';

export const isOnCallFlag = 'isOnCallFlag';

export const isUseWorkorderInPunch = 'isUseWorkorderInPunch';

export const isProjectEntry = 'isProjectEntry';

export const isActivityEntry = 'isActivityEntry';

export const isTaskEntry = 'isTaskEntry';

export const isUseAbc = 'isUseAbc';

export const isUseActivityRemark = 'isUseActivityRemark';

export const isBlockAssocWorkorderInPunch = 'isBlockAssocWorkorderInPunch';

export const useOtherClassification = 'useOtherClassification';

export const isUseOrderFormReq = 'isUseOrderFormReq';

export const useRequisitionCodeOnPunch = 'useRequisitionCodeOnPunch';

export const usePersonnelRequisitionMileage = 'usePersonnelRequisitionMileage';

export const vacColor = 'vacColor';

export const holidayColor = 'holidayColor';

export const offColor = 'offColor';

export const pshColor = 'pshColor';

export const absColor = 'absColor';

export const useDoubleApprobation = 'useDoubleApprobation';

export const approbationStructure = 'approbationStructure';

export const isLevel2Approbator = 'isLevel2Approbator';

export const isApprobationLv1Mandatory = 'isApprobationLv1Mandatory';

export const isUseCCQStatus = 'isUseCCQStatus';

export const isUseCCQTask = 'isUseCCQTask';

export const isDisplayChatMenu = 'isDisplayChatMenu';

export const isDisplayExpenseAccountClassif = 'isDisplayExpenseAccountClassif';

export const isSuperUser = 'isSuperUser';

export const allowConsultation = 'allowConsultation';

export const isRefusalRequestMandatoryComment = 'isRefusalRequestMandatoryComment';

export const selectedMenu = 'selectedMenu';

export const redirectMenu = 'redirectMenu';

export const allowApprobation = 'allowApprobation';

export const isActivityAssocWorkorderInPunch = 'isActivityAssocWorkorderInPunch';

export const isUseBankExtraTime = 'isUseBankExtraTime';

export const isUseExtraTimePay = 'isUseExtraTimePay';

export const isUseWorkorder = 'isUseWorkorder';

export const isDepartmentMandatoryOnProject = 'isDepartmentMandatoryOnProject';

export const isPayProjectWithSkills = 'isPayProjectWithSkills';

export const commentForApprovOnPunch = 'commentForApprovOnPunch';

export const defaultSubcodTransacWithExtraTimeBank = 'defaultSubcodTransacWithExtraTimeBank';

export const defaultSubcodTransacWithExtraTimePay = 'defaultSubcodTransacWithExtraTimePay';

export const defaultABCProjectHoliday = 'defaultABCProjectHoliday';

export const defaultABCProjectHolidayCrypt = 'defaultABCProjectHolidayCrypt';

export const defaultABCActivityHoliday = 'defaultABCActivityHoliday';

export const defaultABCActivityHolidayCrypt = 'defaultABCActivityHolidayCrypt';

export const defaultPayProjectHoliday = 'defaultPayProjectHoliday';

export const defaultPayActivityHoliday = 'defaultPayActivityHoliday';

export const defaultPayTaskHoliday = 'defaultPayTaskHoliday';

export const defaultWorkOrder = 'defaultWorkOrder';

export const hasEmploymentStatusOnShift = 'hasEmploymentStatusOnShift';

export const isDisplayJobTitleProfileByDepartment = 'isDisplayJobTitleProfileByDepartment';

export const isDisplayPayProjectProfileByDepartment = 'isDisplayPayProjectProfileByDepartment';

export const isDisplayShiftProfileByProject = 'isDisplayShiftProfileByProject';

export const isDisplaySubcodeProfileByDepartment = 'isDisplaySubcodeProfileByDepartment';

export const isDisplaySubcodeProfileByJobTitle = 'isDisplaySubcodeProfileByJobTitle';

export const isDisplaySubcodeProfileByProject = 'isDisplaySubcodeProfileByProject';

export const isLinkProjectActivityTaskP = 'isLinkProjectActivityTaskP';

export const isProjAssocWorkorderInPunch = 'isProjAssocWorkorderInPunch';

export const isDefaultApprovManEntryApprovalPortal = 'isDefaultApprovManEntryApprovalPortal';

export const isJobTitleEntry = 'isJobTitleEntry';

export const isPayProjectLoadedFromWorkorder = 'isPayProjectLoadedFromWorkorder';

export const isWorkOrderLinkedToDepartment = 'isWorkOrderLinkedToDepartment';

export const useFilePunch = 'useFilePunch';

export const useDailyReport = 'useDailyReport';

export const useEventReport = 'useEventReport';